import React, {Component} from 'react'


class ChatAnalyticsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    async loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        })
    }

    async initKapchat() {
        if (window.Kapchat)
        window.Kapchat.initialize({
            key: '4f2c68711d4d8bbf59d882037a0f6c876dc9a2797148463918',
            label: 'Chat For Support',
            widget: 'kp_widget_tk',
            success: function() {
                // your callback here (optional)
            },
            error: function(e) {
                console.log(e);
            }
        });
    }

    async initSupportScript() {
        var res = await this.loadScript("https://www.adjetter.com/static/assets/global/plugins/supportmessenger/js/kapturesupport.nojquery.min.js")
        
        if (!res)
            return;
        return res;
    }

    async componentWillMount() {
        var res = await this.loadScript(`https://www.adjetter.com/static/assets/global/plugins/supportmessenger/js/kapanalytics.min.js`);
        
        if (!res)
            return;
        
        var res1 = await this.loadScript("https://www.adjetter.com/static/assets/global/plugins/jquery.min.js")
        
        if (!res1)
            return;
        
        await this.initSupportScript();
        this.initKapchat()
        // $("#kapture-register-form").kapAnalytics();
    }

    render() {
        return (
            <div>   </div>
        )
    }
}

export default ChatAnalyticsComponent;
